import { Box } from "@mui/material";
import { linear_content_style } from "../../../libs/linear-layout/LinearLayout";
import Markdown from "../../../libs/markdown/Markdown";
import MarkdownBlock from "../../../libs/markdown/MarkdownBlock";

const FrmSpwkToHisRule = () => {
  return (
    <div style={linear_content_style}>
      {md_Headline()}
      <br />
      {md_TODO()}

      {md_Block_A01基本檔()}
      {md_Block_B01()}
      {md_Block_B02()}
      {md_Block_B05()}
      {md_Block_B10()}
      {md_Block_B16()}
      {md_Block_B19()}
      {md_Block_B23()}
      {md_Title1()}
      {md_Block1()}
      {md_Block2()}

      {md_Title2()}
      {md_Block1()}
      {md_Block2()}
      {md_Block3()}
      <br />
      <br />
    </div>
  )

  function md_TODO() {
    return (<><MarkdownBlock title="TODO" defaultExpanded={true}>
      <Markdown anchor_id="" className="px-0">{`
### TODO
- [ ] 健檢候補匯入實際體檢日期，與環境作業(如果有)
- [ ] 合併時應優先保留有 input 的選項，如果遇到 input 數量不合的情況，應該爆掉
- [ ] 請健檢中心設定 Trigger

### 基本特作問卷轉檔匯入流程說明 ###

#### 基本架構
- 題目透過以下定義
  - UniFunc(特作編號) --- A01、A98、B02...
    - UniForm(表單版本) --- v0、v1...
      - UniQuestion(題目) --- 標題、單選、多選、非選...
        - UniOption(選項) --- 勾選的項目 或 非選的文字描述
          - UniInput(輸入文字/其他之類的) --- 輸入 文字、數值、日期...
- 每人會依照院內特作定義，事先匯入
    - 匯入時會自動產生一個對應的答卷 UniAnswer
    - UniAnswer 會依照匯入當時的個案資訊，預先填寫
    - 如果重新匯入，會改變所有 UniProject、UniMember 的基本資料
    - 如果重新匯入，UniAnswer 只會改變當初匯入的基本資料，以填寫的不會動到
- 每份特作 UniAnswer 包含一筆 BaseForm 與 多筆 SpwkForms
    - BaseForm 是定義多張表單共用的題目，如: 基本資料、檢查時期、作業經歷、生活習慣、環境監測...
    - SpwkForms 則是每選一個特作，就會多一份，主要定義: 特作工時、CH04既往病史、CH06自覺症狀...
-------------------------
### 合併規則
- 顯示畫面時，先撈出所有 BaseForm 與 SpwkForms，及其底下所有的題目、選項...
- BaseForm 事先定義 CH04既往病史、CH06自覺症狀 的 '疾病分類標題
- 對所有 SpwkForms 把所有對應的疾病放入正確的 '疾病分類標題' 內。
- 此時 '疾病分類標題' 的選項可能重複，必須依照 option_code 篩選排除重複的選項
- 調整補上 無 或移除多的 無
- 移除完全沒有選項，或只剩下 無 的題目
- CH04既往病史、CH06自覺症狀 填寫時為特例，是完全打平的一階格式，而非立體的格式
-------------------------
#### 資料準備
- 所有轉檔相關的都放在 export_spwk 資料夾中
- 主要由 ExportManager 控制
- ExportManager.RunExportOneAnswer(ans, base, spwk_forms) --- 可以對單個 UniAnswer 產出轉檔結果

#### 中繼檔 SpwkMetaData
- 取得空白中繼表並填入數值 \`ExportManager.GetMetaTable_and_FillRhfValue()\`
  - 將原始的介面以資料方式重現產出 中繼檔，中繼檔的題目應該與'院內的畫面'跟'職安屬Word'一樣
  - 中繼檔 每個特作 一份
  - 此後將原本合併填寫的答案，先不管三七二十一填上去。
- 將數值合理化 \`ExportNormalizor.RunNormalization()\`
  - 選項如果先前被拆分，則此時會自動補回本選項
  - 觸發Trigger: 如果有設定 肺癌 屬於癌症 之類的。 則此時，看到 肺癌 勾起來，就會巡過所有選項，自動將 癌症 勾起來
  - 拆分後的答案，可能會缺少 "無"，需要在此判斷補回
  - 拆分後的其他，文字答案，在此合理化回填，或將選項填入 其他 中
------------------------------
#### 開始轉檔
- \`A. ExportManager.ConvertTo_ExportBundle()\` --- 透過此方法轉檔
- 主要包含以下方法，先做摘要地圖:
    - B. ExportManager.ConvertTo_基本檔_and_特作行() --- 負責院內資訊最原本的xls格式
      - C. HisBasicParser_基本檔.__ConvertTo_基本檔() --- 轉換為 \`問卷基本檔.xlsx\` 格式
      - D. HisRowHelper.__ConvertTo_特作行() --- 轉換為 \`A01問卷.xlsx\` \`B02問卷.xlsx\`... 格式
    - E. GovRowHelper.ConvertTo申報格式() --- 負責政府的申報格式 \`B01問卷申報.xlsx\`... 格式

#### 轉檔細節
##### C. 轉基本檔 HisBasic
- HisBasicParser_基本檔.SetHisBasicValue_ByDefine()
    - 透過此方法，依照定義轉檔
    - 標準是讀取 his_code 依照 {姓名} {身份證號}.... 依照資料類型分別讀取
    - 注意 custom 規則，遇到時在 \`HisBasicParser_基本檔.FindHisBasicValue_ByCustomRule()\` 解碼
##### D. 轉特作行 HisRow
- HisRowHelper.__ConvertTo_特作行()
    - GetSpwkHisStepList() 先取得不同特作不同順序的解碼規則
    - 依照規則逐一查表轉檔 \`export_spwk/HisRowParser_OOO.tsx\`，每一章節的轉當方式都放在個別的檔案中
##### E. 轉申報行 GovRow
- GovRowHelper.ConvertTo申報格式()
    - 與 D 同理，GetSpwkGovStepList() 取得不同順序步驟
    - 依照規則逐一查表轉檔 \`export_spwk/GovRowParser_OOO.tsx\`，每一章節的轉當方式都放在個別的檔案中
--------------------------------
### 轉院內API格式
- 做完以上步驟，會將填寫的 UniAnswer 轉為 院內給的 xls 格式，但還需要進一步轉為 API 開通的格式
>
> (TODO)
>
- HisDtoManager --- 接下來以這個 class 負責將 原本的 xls 格式，轉為院內API要求的格式


`}
      </Markdown>
      <Box></Box>
    </MarkdownBlock></>);
  }

  function md_Headline() {
    return <Markdown>{`

特作問卷匯入院內 - 轉檔規則筆記
==============================
\`FrmSpwkToHisRule\`  
- 重要參考路徑: \`/#線上問卷 ★★★/#正式開發問卷資料 ★★★/HIS格式\`
- his_code參考檔案: \`★ 勞健問卷答案_1120213.xlsx\`

### 連結 ###
- [CCC](#block3)  
`}
    </Markdown>
  }

  function md_Title1() {
    return <Markdown>{'\n\n標題1\n---'}</Markdown>
  }



  function md_Block_A01基本檔() {
    return (<><MarkdownBlock title="A01" defaultExpanded={true}>
      <Markdown anchor_id="" className="px-0">{`
### A01基本檔
- 參考檔案: \`問卷基本檔-大部分特作.xlsx\`
- 性別是 M/F
- 日期格式是 YYYY/MM/DD 沒填則空白
- 曾經從事 工作空白時 會填上 "無"
- A01沒有 '本作業平均工時' B01~B32 則有
- 是否輪班: 以 Y/N 填寫，目前已 '輪班幾班制' 的答案自動判斷，固定班別=N, 此外為=Y
- 輪班幾班制: 預設帶入答案的數字 (1固定、2、3、4班制)，如果選擇其他，則設為 'o' (other)

-----------------------------

### A01特作行
- 參考檔案: \`A01問卷.xlsx\`

#### 檢查時期
- 類別: 類別(章節)總是為 "3"，且只有項目(題號)"1"， 答案: 1新進、2定期、3變更、4追蹤
- A01: 只會有 1新進/2定期

#### 既往病史
- 類別: 類別(章節)總是為 "4"
- his_code參考檔案: \`★ 勞健問卷答案_1120213.xlsx\`，一一對照
- 文字答案: 4_19#左手腕@4_20#左手腕 (4是類別、19,20是勾選的項目，以@分隔) 

#### 生活習慣
- 類別: 類別(章節)總是為 "5"
- 類別: 項目(題號)總是為 "1"、"2"、"3" (吸菸、喝酒、檳榔)，睡眠時數是存在'基本檔'的，不在這裡
- 注意! A01 最早的範例3題都填寫 "5_1_3#10@25" 是錯誤的，資訊已改掉。

#### 自覺症狀
- his_code參考檔案: \`★ 勞健問卷答案_1120213.xlsx\`，一一對照
- 全部勾掉應該是 24 以上皆無

### 環境作業
- A01 不需要環境作業

-----------------------------

### A01申報行
- A01 不用申報，所以空白


`}
      </Markdown>
      <Box></Box>
    </MarkdownBlock></>);
  }
  function md_Block_B01() {
    return (<><MarkdownBlock title="B01" defaultExpanded={true}>
      <Markdown anchor_id="" className="px-0">{`
### B01申報行
- B01 二-04-答題內容01還是1 ? [V]
    先用if下去寫死跟問卷申報Excel長一樣
- B01 問題類別 4 編號 04 沒有顯示 [V]
    定義檔補上去
`}
      </Markdown>
      <Box></Box>
    </MarkdownBlock></>);
  }
  function md_Block_B02() {
    return (<><MarkdownBlock title="B02" defaultExpanded={true}>
      <Markdown anchor_id="" className="px-0">{`
### B02明細檔
- 第2章項目52在51結果為8的時候應該要為'' [V]
- 作業經歷,'521#@522#@523#@524#'='' [V]
- 第6章項目1結果61系列處理 [V]
- 自覺症狀,undefined='' [V]
- 第4章項目1結果32#2@32#@處理(32#1可能要再加判斷) [V]
  既往病史,if判斷
### B02申報行
- 5-0104應該要顯示出來 [V]
- 2-4系列順序要調整 [V]
    生活習慣,if判斷


`}
      </Markdown>
      <Box></Box>
    </MarkdownBlock></>);
  }
  function md_Block_B05() {
    return (<><MarkdownBlock title="B05" defaultExpanded={true}>
      <Markdown anchor_id="" className="px-0">{`
### B05明細與申報檔
- 區分男女 [V]
- 勾不孕症19跟22會一起勾 [V]
  好像改設定檔就好了
  改了HisRowParser_既往_自覺27~32，方法多加了一個gender進去
`}
      </Markdown>
      <Box></Box>
    </MarkdownBlock></>);
  }
  function md_Block_B19() {
    return (<><MarkdownBlock title="B19" defaultExpanded={true}>
      <Markdown anchor_id="" className="px-0">{`
### B19明細與申報檔
- 在轉換過程增加 是否有以下生活習慣 [V]
  增加判斷式 if
`}
      </Markdown>
      <Box></Box>
    </MarkdownBlock></>);
  }
  function md_Block_B10() {
    return (<><MarkdownBlock title="B10" defaultExpanded={true}>
      <Markdown anchor_id="" className="px-0">{`
### B10Word檔
- 自覺症狀 5.其他-其他沒有input
`}
      </Markdown>
      <Box></Box>
    </MarkdownBlock></>);
  }
  function md_Block_B16() {
    return (<><MarkdownBlock title="B16" defaultExpanded={true}>
      <Markdown anchor_id="" className="px-0">{`
### B16自覺症狀
- 出現尚未定義
`}
      </Markdown>
      <Box></Box>
    </MarkdownBlock></>);
  }
  function md_Block_B23() {
    return (<><MarkdownBlock title="B23" defaultExpanded={true}>
      <Markdown anchor_id="" className="px-0">{`
### B23申報檔
- 呼吸困難(1-5)下拉式1-5
已經改下拉式了
- 1.假設不是所有呼吸困難都是下拉式應該要優先保留有input的下拉式
- 2.在合併時遇到opt_code一樣的時候優先保留有input的選項，if兩個選項數量不是0且不一致拋出例外
- 3.轉檔時該怎麼辦
- 4.填表說明
`}
      </Markdown>
      <Box></Box>
    </MarkdownBlock></>);
  }



  function md_Block1() {
    return (<><MarkdownBlock title="區塊1" defaultExpanded={true}>
      <Markdown anchor_id="" className="px-0">{`
### 區塊1
- AAA
- BBB
- CCC
`}
      </Markdown>
      <Box></Box>
    </MarkdownBlock></>);
  }

  function md_Block2() {
    return (<><MarkdownBlock title="區塊2" defaultExpanded={true}>
      <Markdown anchor_id="" className="px-0">{`
### 區塊2
- AAA
- BBB
- CCC
`}
      </Markdown>
      <Box></Box>
    </MarkdownBlock></>);
  }

  function md_Block3() {
    return (<><MarkdownBlock title="區塊3">
      <Markdown anchor_id="block3" className="px-0">{`
### 區塊3
- AAA
- BBB
- CCC
`}
      </Markdown>
      <Box></Box>
    </MarkdownBlock></>);
  }

  function md_Title2() {
    return <Markdown>{'\n\n標題2\n---'}</Markdown>
  }

}


export default FrmSpwkToHisRule